import React, { useState } from 'react';
import styles from './input.module.scss';
import { Box } from '@mui/material';
import OtpInput from 'react-otp-input';
import ERCSelect from './Select';
import { FaEye, FaEyeSlash } from "react-icons/fa";  // FontAwesome Icons


const OTPInput = (props) => {
    const [otp, setOtp] = useState();
    return (
        <OtpInput
            value={otp}
            onChange={setOtp}
            containerStyle={{ width: '100%' }}
            inputStyle={{ width: '100%', color: 'red' }}
            {...props}
            numInputs={4}
            shouldAutoFocus
            skipDefaultStyles
            renderSeparator={<span className="mx-3"></span>}
            renderInput={(inputProps) => <input {...inputProps} />}
        />
    );
};

const ERCInput = ({
    hidden,
    style,
    label,
    type = 'text',
    containerClass,
    selectClass,
    width,
    height,
    onChange = () => null,
    getObj = () => null,
    ...props
}) => {
    const [showPassword, setShowPassword] = useState(false);
    
    const change = (e) => {
        onChange(e);
        getObj({ [e.target.name]: e.target.value });
    };

    const input_id = 'input-id';
    const defaults = ['text', 'password', 'email', 'number'];
    const inputStyles = {
        width: width,
        height: height,
        boxSizing: 'border-box'
    };

    return (
        <Box style={style} className={`${styles.container} ${containerClass}`}>
            <Box component={'label'} htmlFor={input_id}>
                {label}
            </Box>
            
            {type === 'otp' && <OTPInput onChange={change} {...props} />}
            {type === 'select' && <ERCSelect selectClass={`${selectClass}`} {...props} onChange={onChange} />}

            {defaults.includes(type) && (
                <div className="relative w-full">
                    <input
                        type={type === 'password' && showPassword ? 'text' : type}
                        style={inputStyles}
                        className='w-full'
                        onChange={change}
                        {...props}
                    />
                    {type === 'password' && (
                        <button
                            type="button"
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <FaEye size={20} color='#cccc' /> : <FaEyeSlash size={20} color='#cccc'  />}
                        </button>
                    )}
                </div>
            )}
        </Box>
    );
};

export default ERCInput;
